import { ModeType } from '@eastcoal/common/types/build'

/**
 * 构建模式
 */
export const BUILD_MODE = import.meta.env.MODE as ModeType

/**
 * API 服务地址
 */
export const API_SERVER_URL = import.meta.env.VITE_API_SERVER_URL

/**
 * mall 服务地址
 */
export const MALL_BASE_URL = import.meta.env.VITE_MALL_BASE_URL

/**
 * member 服务地址
 */
export const MEMBER_BASE_URL = import.meta.env.VITE_MEMBER_BASE_URL

/**
 * operation 服务地址
 */
export const OPERATION_BASE_URL = import.meta.env.VITE_OPERATION_BASE_URL

/**
 * support 服务地址
 */
export const SUPPORT_BASE_URL = import.meta.env.VITE_SUPPORT_BASE_URL

/**
 * weboffice 服务地址
 */
export const WEB_OFFICE_SERVER_URL = import.meta.env.VITE_WEB_OFFICE_SERVER_URL

/**
 * weboffice 应用 ID
 */
export const WEB_OFFICE_APP_ID = import.meta.env.VITE_WEB_OFFICE_APP_ID

/**
 * 阿里云用户体验监控应用 ID
 */
export const RUM_APP_ID = 'ch1nb@f50b9824fe41c3a'

/**
 * Donut 产品体验分析应用 ID
 */
export const WXOBS_APP_ID = 'wxcf618d48bf0581d5-tFGDi0qVO-PlW_Aa'

/**
 * 应用版本号
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || BUILD_MODE

// 加密 key 和 iv
export const CIPHER_SECRET = import.meta.env.VITE_CIPHER_SECRET
export const CIPHER_IV = import.meta.env.VITE_CIPHER_IV
